export default function () {
  const widgetName = 'topHeaderLinks';
  const widgetOpts = topHeaderLinksOpts;

  function createNavLinks(slide) {
    const itemsData = slide.items;
    const navLinks = $('.mobile-menu-footer-links');
    let newlinks = '';
    itemsData.forEach((item) => {
      const url = item.URL;
      const text = item.Title;
      newlinks += `<a href="${url}">${text}</a>`;
    });
    navLinks.prepend(newlinks);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (slide) {
      createNavLinks(slide);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
